
import organization from './config-organization';
import position from './config-position';
import WizTableForm from "../wizTableForm";

const organizationConfig = organization(this, { apiParams: { state: 1, organizationNodeCategory:["2"] } });
const positionConfig = position(this, { apiParams: { state: 1 } });

const columns = () => {
  return [
    {
      title: '能力考核项目',
      name: 'categoryName',
      dataIndex: 'categoryName',
      tableItem: {
        width: 220
      },
      searchItem: {}
    },
    {
      title: '能力评估星级',
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 220
      },
      searchItem: {}
    },
    {
      title: '品牌',
      name: 'orgId',
      dataIndex: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '岗位',
      name: 'positionIdList',
      dataIndex: 'positionIdList',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm
      }
    },
    {
      title: '品牌',
      name: 'orgName',
      dataIndex: 'orgName',
      tableItem: {
        width: 220
      }
    },
    {
      title: '岗位',
      name: 'positionNames',
      dataIndex: 'positionNames',
      tableItem: {
        width: 360
      }
    },
    {
      title: '状态',
      name: 'state',
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' },
      ],
      dataIndex: 'state'
    }
  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'abilityCheckItem/listByPage',
    ...api
  }
};

const abilityCheckItem = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    tableApi: tableApi(api)
  }
};

export default abilityCheckItem
